"use client";

import { useStytchB2BClient } from "@stytch/nextjs/b2b";
import { useCallback, useRef } from "react";
import { mutate } from "swr";
import { profileURL } from "../../hooks/use-profile";
import { reportLogin } from "../../lib/analytics";
import { logError } from "../../logging/logger";
import { useUser } from "../../providers/user-provider";
import { usePostAuthRedirect } from "./use-post-auth-redirect";

export const useAuthCompletion = (defaultReturnTo?: string) => {
  const { setPauseFetchProfile } = useUser();
  const { redirectAfterLogin } = usePostAuthRedirect(defaultReturnTo || "/");
  const stytchB2BClient = useStytchB2BClient();
  const hasCompletedRef = useRef(false);

  const onAuthComplete = useCallback(async () => {
    if (hasCompletedRef.current) {
      return;
    }
    hasCompletedRef.current = true;
    try {
      setPauseFetchProfile(false);
      await mutate(profileURL);
      const email = stytchB2BClient.self.getSync()?.email_address;
      if (email) {
        reportLogin(email);
      }
      redirectAfterLogin();
      hasCompletedRef.current = false;
    } catch (error) {
      logError(error instanceof Error ? error : new Error(String(error)));
    }
  }, [setPauseFetchProfile, redirectAfterLogin, stytchB2BClient]);

  return { onAuthComplete } as const;
};
